import { render, staticRenderFns } from "./FooterApp.vue?vue&type=template&id=683340cd&scoped=true&"
import script from "./FooterApp.vue?vue&type=script&lang=js&"
export * from "./FooterApp.vue?vue&type=script&lang=js&"
import style0 from "./FooterApp.vue?vue&type=style&index=0&id=683340cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683340cd",
  null
  
)

export default component.exports